// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {
  Banner,
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../Banner';

export const BannerWithMargin = styled(Banner)`
  margin: 8px 0;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';

export const RegisteredModelLimitReachedBanner = () => {
  return (
    <BannerWithMargin variant="error">
      <BannerFlexWrapper>
        <Icon name="warning" />
        <BannerTextWrapper style={{display: 'inline'}}>
          <BannerBoldText>Free Model Registry limit reached.</BannerBoldText>{' '}
          You have reached your organization's limit of free Model Registry
          usage. Please contact us to increase the limit.
        </BannerTextWrapper>
      </BannerFlexWrapper>
    </BannerWithMargin>
  );
};
